import type { ValidationErrorMessage } from '@festina/configuration-general-types/configuration'
import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import { configurationKeys } from '@festina-life/api'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { fetchAllWorkspaceBranchChangesetsKey } from '../keys'

type PushWorkspaceProps = {
  server: ConfigurableServer
  workspaceName: string
  branchName: string
}

type PushArguments = {
  description: string
}

export const usePushWorkspaceOperationsToConfigurationComponent = ({
  server,
  workspaceName,
  branchName,
}: PushWorkspaceProps) => {
  const queryClient = useQueryClient()
  return useMutation<void, ValidationErrorMessage, PushArguments>({
    mutationFn: async ({ description }) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostPushWorkspace(
        {
          requestBody: {
            _type: 'WorkspacePushSpecification',
            workspaceName,
            changesetDescription: description,
            componentName: server.toLocaleLowerCase(),
          },
        },
      )
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchWorkspaceOperationsKey({
          workspaceName,
          server,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: fetchAllWorkspaceBranchChangesetsKey({
          workspaceName,
          componentName: server,
          baseBranchName: branchName,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchWorkspaceAllErrorsKeyPrefix({
          workspaceName,
          server,
        }),
      })
    },
  })
}
